import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'vq-form-factory',
  templateUrl: './form-factory.component.html',
  styleUrls: []
})
export class FormFactoryComponent implements OnInit {

  @Input('vqModel') model:any;
  @Input('vqModule') module:any;
  @Input('vqLabel') label:string;
  @Input('vqStep') step:string = 'any';
  @Input('vqLabelGetter') labelGetter:any;
  @Input('vqPlaceholder') placeholder:string;
  @Input('vqValueGetter') valueGetter:any;
  @Input('vqDisplayLabel') displayLabel:boolean=true;
  @Input('vqOptions') options:Array<string> = [];
  @Input('vqErrors') errors:Array<string> = [];
  @Input('vqHelpText') helpText:string;
  @Input('vqApiService') apiService:any;
  @Input('vqFilter') filter:any;
  @Input('vqDebounce') debounce:any;
  @Input('vqDefaultValue') defaultValue:any = '';
  @Input('vqType') type:any;
  @Input('vqClassList') classList:any;

  @Output('vqTrigger') trigger:EventEmitter<any> = new EventEmitter<any>();
  @Output('vqModelChange') modelChange:EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  public onTrigger($event, select=false) {
     this.trigger.emit($event);
  }

  public isModule(mod:string):boolean {
    return this.module === mod;
  }

  public changeRange($event){
    this.model = this.model.map( o =>{
      Object.keys($event).map( r =>{
        if(o.key == r) o.value = $event[r];
      })
      return o;
    })
    this.modelChange.emit($event);
  }

  public change($event, select=false) {
    this.model = $event;
    this.modelChange.emit($event);
    if (select) {
      this.onTrigger($event);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/vqforms/form-factory/form-factory.component.ts